import { lazy } from 'react'
import suspenseComponent from '../../util/suspenseComponent'

let BarcodeScannerModal = lazy(() => import('./BarcodeScannerModal'))
BarcodeScannerModal = suspenseComponent(BarcodeScannerModal)

export default BarcodeScannerModal
